export default __webpack_public_path__ + "static/media/bolt-logo-dark.ee3e9bb2.svg";